"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('dotenv').config();
var HOSTS = {
    development: {
        application: 'https://app.listen360.localhost',
        api: 'https://app2.listen360.localhost'
    },
    test: {
        application: 'http://localhost:3005',
        api: 'http://localhost:3002'
    },
    production: {
        application: 'https://app.listen360.com',
        api: 'https://app2.listen360.com'
    }
};
var config = {
    hosts: HOSTS,
    applicationBaseUrl: HOSTS[process.env.NODE_ENV].application,
    apiBaseUrl: HOSTS[process.env.NODE_ENV].api + "/api"
};
exports.default = config;
//# sourceMappingURL=config.js.map